import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { OrgHeadends } from '../models/OrgHeadends';

@Injectable()
export class HeadendService {

  constructor(private http: Http) {}

    getByRegionId(regionId: number): Observable<any> {
      const url = environment.api.baseUrl + environment.api.headend.replace('{regionId}', regionId.toString());
      return this.http.get(url).map(res => {
        return res.json().map(j => new OrgHeadends(j));
      });
    }
  }



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/headend.service.ts